module.exports = __webpack_public_path__ + "media/directory/avatar_icon_hover-0ca9548b.svg";